<template>
  <transition name="fade">
    <div class="loading-modal" v-if="isLoading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden"></span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "loadingModal",
  data() {
    return {
      isLoading: true,
    };
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 1500);
  },
};
</script>

<style>
.loading-modal {
  position: absolute;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  height: 100vh;
  width: 100%;
}
</style>
